/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, Inject, Optional } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceInRequiredValidator } from '../../../shared/constants';
import { NavbarComponent } from '../../../navbar/navbar.component';

@Component({
	selector: 'app-labtest-form',
	templateUrl: './labtest-form.component.html',
	styleUrl: './labtest-form.component.css'
})
export class LabtestFormComponent implements OnChanges {
	moduleForm!: FormGroup;
	get f() { return this.moduleForm.controls; }
	showLoader = false;
	pageLoading = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	countryCodes: any = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.moduleForm = this.formBuilder.group({
			name: ['', [Validators.required, noWhitespaceInRequiredValidator]],
			description: ['', [Validators.required, noWhitespaceInRequiredValidator]]
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['uId']) {
			if (this.uId) {
				this.getDetails();
			}
		}
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getLabTest({ id: this.uId }).subscribe({
			next: (data: any) => {
				const obj = data.data;
				this.moduleForm.setValue({
					name: obj.name,
					description: obj.description
				});
				this.pageLoading = false;
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			name: this.f.name.value,
			description: this.f.description.value
		};
		if (this.uId) {
			data.id = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateLabTest(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							const val: any = value;
							if (val[0] == "This field must be unique.") {
								val[0] = "Already exists";
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val[0];
								const selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val[0], 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}
						}
						return;
					} else {
						errorMsg = "Test already exists";
					}
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
